$(function () {
    var PRINT_ONLY = "print-only";
    var NOT_FULL_ON_PRINT = "not-full-on-print";

    var handleImages = function () {
        $(".section a:has(img)").each(function () {
            var spanPrintTemplate = "<span class='print-only' style='display: none;'></span>";

            var img = $(this).find("img");
            var altText = img.attr("alt");

            var printSpan = $(spanPrintTemplate).text(altText);
            $(this).append(printSpan);
        });
    };

    var handleColumnsOfImages = function(){
        var rows = $(".img-fluid").parents(".row");

        //Only applies if more than one image on the same row and there is no accordion
        rows.each(function () {
            if($(this).find("img").length > 1 && $(this).has(".accordion").length === 0)
                $(this).children().addClass(NOT_FULL_ON_PRINT);

        });
    };

    var handleTitle = function () {
        var headerComponent = $(".header_image_component");

        headerComponent.find("p").each(function () {
            if ($(this).html()) {
                headerComponent.addClass(PRINT_ONLY);
            }
        });
    };

    var handleReadMoreButton = function () {
        $(".read_more").addClass(PRINT_ONLY);
    };

    //The deepest column should be marked in other to apply specific css rules for those columns
    var markDeepestColumns = function(){
        $(".component_section").deepest(".row").children().addClass("deepest-column");
    };

    //Columns which doesn't have image (mainly text) should be breakable
    var markNoImageColumns = function(){
        $(".deepest-column").not(":has(img)").addClass("no-image-column");
    };

    var preparePage = function () {
        handleColumnsOfImages();
        handleImages();
        handleTitle();
        handleReadMoreButton();
        markDeepestColumns();
        markNoImageColumns();
    };

    var init = function () {
        preparePage();
    }

    init();
});


